import { z } from "zod";

/**
 * The role people created by the Personio sync receive at join. `null` unsets it — the sync
 * then refuses until a role is configured again, rather than creating people who hold nothing.
 */
export const patchPersonioSyncRoleSchema = z.object({
	syncRoleId: z.uuid().nullable(),
});

export type PatchPersonioSyncRoleSchema = z.infer<typeof patchPersonioSyncRoleSchema>;
